'use client';
import { useBrand } from '@curology/ui-components-web/brand/context';
import { NavigationCta } from '@curology/ui-components-web/react/Navigation/NavigationCta';
import { usePathname } from 'next/navigation';

import { flushFeatureTracking } from '@/utils/featureFlags/client';

import { getLoginUrlWithRedirect } from './helpers/navbarHelpers';

export const LoginButton = () => {
  const brand = useBrand();
  const currentPath = usePathname();
  const loginUrlWithRedirect = getLoginUrlWithRedirect(brand, currentPath);
  return (
    <NavigationCta
      onClick={() => {
        flushFeatureTracking(() => {
          window.location.assign(loginUrlWithRedirect);
        });
      }}
      buttonType="secondary"
    >
      Log in
    </NavigationCta>
  );
};
